import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import WishlistButton from './WishlistButton';
import WishlistAdd from './Wishlist.add';
import {
    setIncludedInWishlists,
    setIsInWishlist,
} from '../Actions/Wishlist.action';

const WishlistButtonContainer = (props) => {
    const [showInfo, setShowInfo] = useState(false);
    const inWishlist = useSelector((state) => state.wishlist.inWishlist);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setIncludedInWishlists(props.includedInWishlistsArray));
        dispatch(setIsInWishlist(props.includedInWishlistsArray?.length > 0));
    }, [props.includedInWishlistsArray, dispatch]);

    const onToggle = () => {
        setShowInfo(!showInfo);
    };

    useEffect(() => {
        const button = document.getElementById('wishlistbutton-placeholder');

        if (button) button.classList.remove('loading');
    }, []);
    return (
        <div className="wishlist-button-container">
            {showInfo == true && (
                <WishlistAdd
                    onClose={() => onToggle()}
                    articleNumber={props.articleNumber}
                    addCart={props.addCart}
                />
            )}
            <WishlistButton
                {...props}
                cssClass={
                    inWishlist
                        ? 'wishlist-button--is-in-wishlist'
                        : 'wishlist-button'
                }
                onClick={() => onToggle()}
            />
        </div>
    );
};

export default WishlistButtonContainer;
